import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './WorkWithUs.css';

function WorkWithUs() {
  const [expandedJob, setExpandedJob] = useState(null);

  const positions = [
    { 
      title: 'Talent Agent', 
      dept: 'Management', 
      location: 'Remote',
      companyDesc: 'Alooma Media Group, Inc. is your destination for top-tier culinary, lifestyle and entertainment talent. As a full-service talent management agency, we leverage our extensive network to connect our clients with brands, delivering strategic, results-driven partnerships that grow and endure.',
      roleDesc: 'This is a full-time, remote Talent Agent role at Alooma Media Group. The Talent Agent will be responsible for identifying and procuring new clients, building and maintaining relationships with existing clients, and negotiating contracts and deals on behalf of clients. The Talent Agent will also have a deep understanding of the entertainment industry and a strong network of industry contacts.',
      qualifications: [
        '2+ years of experience in talent management, with a focus on representation of creators, musicians, athletes or entertainment professionals',
        'Experience working with culinary/food creators is a big plus',
        'Experience working with brands and executing marketing campaigns',
        'Proven ability to identify and sign new talent',
        'Excellent communication and negotiation skills',
        'Strong industry contacts and knowledge of the entertainment industry landscape',
        'Ability to multitask and prioritize in a high-pressure, fast-paced environment',
        'A Bachelor\'s degree in a related field is preferred',
        'Experience with contract negotiation and deal-making',
        'Excellent problem-solving and analytical skills',
        'Ability to think creatively and outside-the-box to identify new opportunities for clients',
      ]
    },
  ];

  const values = [
    {
      title: 'People First',
      desc: 'We believe in building genuine relationships with our talent and team members.'
    },
    {
      title: 'Creative Excellence',
      desc: 'We push boundaries and champion bold ideas that resonate with audiences.'
    },
    {
      title: 'Integrity Always',
      desc: 'Transparency and honesty guide every partnership and decision we make.'
    }
  ];

  const toggleJob = (index) => {
    setExpandedJob(expandedJob === index ? null : index);
  };

  return (
    <div className="work-with-us-page">
      {/* Hero Section */}
      <section className="careers-hero">
        <div className="careers-hero-content">
          <span className="hero-label">Join Our Team</span>
          <h1 className="hero-headline">
            Redefining the Future of<br />
            <span className="accent">Talent Management</span>
          </h1>
          <p className="hero-subtext">
            We're looking for passionate individuals who believe in the power of 
            storytelling and want to help creators reach their full potential.
          </p>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="section-container">
          <span className="section-label">Our Values</span>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <h3>{value.title}</h3>
                <p>{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Positions Section */}
      <section className="positions-section">
        <div className="section-container">
          <span className="section-label">Open Positions</span>
          <h2 className="section-headline">
            Find Your <span className="accent">Role</span>
          </h2>
          <div className="positions-list">
            {positions.map((job, index) => (
              <div key={index} className={`position-card ${expandedJob === index ? 'expanded' : ''}`}>
                <div className="position-header" onClick={() => toggleJob(index)}>
                  <div className="position-info">
                    <h3 className="position-title">{job.title}</h3>
                    <div className="position-meta">
                      <span>{job.dept}</span>
                      <span className="divider">•</span>
                      <span>{job.location}</span>
                    </div>
                  </div>
                  <button className="position-toggle">
                    <span>{expandedJob === index ? 'Close' : 'View Details'}</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d={expandedJob === index ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"}/>
                    </svg>
                  </button>
                </div>
                
                {expandedJob === index && (
                  <div className="position-details">
                    <div className="job-block">
                      <h4 className="job-block-title">Company Description</h4>
                      <p className="job-block-text">{job.companyDesc}</p>
                    </div>
                    
                    <div className="job-block">
                      <h4 className="job-block-title">Role Description</h4>
                      <p className="job-block-text">{job.roleDesc}</p>
                    </div>
                    
                    <div className="job-block">
                      <h4 className="job-block-title">Qualifications</h4>
                      <ul className="qualifications-list">
                        {job.qualifications.map((qual, qIndex) => (
                          <li key={qIndex}>{qual}</li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="job-apply-block">
                      <p className="apply-text">
                        If you are interested in this position, please email{' '}
                        <a href="mailto:Jobs@aloomamediagroup.com" className="email-link">
                          Jobs@aloomamediagroup.com
                        </a>{' '}
                        with your resume and CV.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="careers-footer">
        <div className="footer-content">
          <p>©2025 ALOOMA. All rights reserved.</p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/aloomamediagroup/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              Instagram
            </a>
            <a href="https://www.linkedin.com/company/alooma-media-group/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
              LinkedIn
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default WorkWithUs;
